import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, finalize, map, Observable } from "rxjs";
import { LoaderService } from "../core/services/loader.service";
import { CalService } from "../core/services/cal.service";
import { Router } from "@angular/router";

export const httpInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
    let preventLoader = false;
    if (req.method == 'POST' && req.url.includes('preventLoader=true')) {
        preventLoader = true;
    }
    if (req.body?.preventLoader || req.params?.get('preventLoader')) {
        preventLoader = true;
    }
    // check form data for preventLoader
    if (req.body instanceof FormData) {
        if (req.body?.get('preventLoader') == 'true') {
            preventLoader = true;
        }
    }

    let loaderService = inject(LoaderService);
    let calService = inject(CalService);
    let router = inject(Router);
    if (!preventLoader)
        loaderService.loadSpinner(true);
    let headers = {'Accept': 'application/json'}; 

    const token = window.sessionStorage.getItem('AuthToken');
    let isPowerBiApi = false;
    try {
        const urlObj = new URL(req.url, window.location.origin);
        isPowerBiApi = urlObj.hostname === 'api.powerbi.com';
    } catch (e) {
        isPowerBiApi = false;
    }
    if(!isPowerBiApi){

        req = req.clone({
            setHeaders: {
                ...headers,
                // 'Accept': 'application/json',
                // 'Authorization': `Bearer ${calService.getAADToken()}`,
                'Authorization': `Bearer ${token}`,
            }
        });
    }
    return next(req).pipe(
        map((event: HttpEvent<any>) => {
            return event;
        }),
        catchError((error: HttpErrorResponse) => {
            //router.navigate(['error']);
            throw (error);
        }),
        finalize(() => {
            // Hide loader when the request completes (success or error)
            if (!preventLoader)
                loaderService.loadSpinner(false);
        })
    );
}
